import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { Link } from "react-router-dom";
import { Reveal, SectionHead } from "./Reveal";
import { faqSchema } from "./Seo";

const renderRich = (text) =>
    text.split(/(\[[^\]]+\]\([^)]+\))/g).map((part, i) => {
        const m = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
        if (!m) return part;
        return (
            <Link key={i} to={m[2]} className="text-gold-deep font-semibold hover:underline">
                {m[1]}
            </Link>
        );
    });

const Faq = ({ faqs, dark = false, title = "Frequently Asked Questions", testid = "faq-section" }) => (
    <section className={`py-16 lg:py-24 ${dark ? "bg-navy grain-overlay" : "bg-bone"}`} data-testid={testid}>
        <script type="application/ld+json">{JSON.stringify(faqSchema(faqs))}</script>
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
            <SectionHead eyebrow="FAQ" title={title} dark={dark} center />
            <Reveal delay={0.1} className="mt-10">
                <Accordion type="single" collapsible className="space-y-3">
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            className={`rounded-lg border px-5 ${dark ? "border-white/10 bg-white/5" : "border-slate-200 bg-white shadow-sm"}`}
                            data-testid={`${testid}-item-${i}`}
                        >
                            <AccordionTrigger className={`text-left text-sm sm:text-base font-semibold py-4 hover:no-underline ${dark ? "text-white" : "text-navy"}`}>
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent forceMount className={`faq-acc-content text-sm leading-relaxed pb-4 ${dark ? "text-slate-300" : "text-slate-600"}`}>
                                {renderRich(f.a)}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default Faq;
